module.exports = __webpack_public_path__ + "static/media/Tertiary.6da87cca.png";